import watch from 'redux-watch';
import template from 'modal/request-swatch.j2';
import { render } from '../../../core/js/components/coreComponent';
import { replaceModalTransition } from '../../../core/js/actions/modalActions';

import {
    saveRequestSwatchSelectionError,
    saveRequestSwatchSelections,
    resetRequestSwatchFormData,
    resetRequestSwatchSelections
} from '../actions/productActions';
import { resetGenericEmailSuccessState } from '../../../core/js/actions/genericEmailServiceActions';

import { debug, info, error } from '../../../core/js/utils/logger';

import { generate } from '../../../core/js/utils/componentUtils';
import { mDom, mDomMaintainInputValsCheckedStateSetInTemplate } from '../../../core/js/utils/renderUtils';

import { init as requestSwatchEmailSignUpInit } from './productRequestSwatchEmailSignupModalComponent';
import { handleUtagEvent } from '../../../core/js/actions/initialActions.js';

import { selectInitialSwatchSaga } from '../sagas/productRequestSwatchSagas';

import { buildSwatchString, getRASMinimumMessage, getRASMaximumMessage } from '../utils/requestSwatchUtils';

function addRequestSwatchPageViewTracking(store) {
    const requestSwatchUtagData = {
        page_id: `${store.getState().core.localizations.containers.analyticsContainer.product_request_swatch_select_page_id}`,
        category_id: `${store.getState().core.localizations.containers.analyticsContainer.help_category_id}`
    };

    store.dispatch(handleUtagEvent(requestSwatchUtagData, 'view'));
}

function firstRender(store) {
    store.runSaga(selectInitialSwatchSaga);
    this.render(store, this);
    addRequestSwatchPageViewTracking(store);
}

function afterCloseAction(store) {
    store.dispatch(resetRequestSwatchFormData());
    store.dispatch(resetRequestSwatchSelections());
    store.dispatch(resetGenericEmailSuccessState());
}

/**
 * Attach component events to DOM
 * @returns {undefined}
 */
function attachEvents(store) {
    const checkboxSelector = '.js-request-swatch-selection__checkbox';
    const labelSelector = '.js-request-swatch-selection__label';
    const primarySelector = '.js-request-swatch-selection-inner';

    $(document).on(this.scopedEvent('click'), this.scopedSelector(primarySelector), (e) => {
        e.stopPropagation();

        const state = store.getState();
        const selectedSwatches = _.get(state, 'product.productRequestSwatch.selectedSwatches', []);
        const swatches = _.get(state, 'product.productRequestSwatch.swatches', []);
        const colorCode = $(e.currentTarget).find(checkboxSelector).val();
        const swatch = _.find(swatches, { colorCode });

        if (swatch) {
            // add or remove swatch depending on symmetric difference (see https://lodash.com/docs#xor)
            const newSelectedSwatches = _.xor(selectedSwatches, [swatch]);
            // NOTE: If you are updating the separator here, also update it in
            // getSelectedSwatchString() in src/sdk/urbnweb/features/mto/js/reducers/rasReducer.js
            const newSwatchesString = _.flow(
                _.partialRight(_.map, (sw) => buildSwatchString(
                    state.product.productRequestSwatch.selectedProduct.styleNumber,
                    '', // No way to infer material name, see UW-24959
                    sw)),
                _.partialRight(_.join, '|')
            )(newSelectedSwatches);

            store.dispatch(saveRequestSwatchSelections(
                newSelectedSwatches,
                newSelectedSwatches.length,
                newSwatchesString,
                true  // flag as user-initiated selection
            ));
        }
    });

    $(document).on(this.scopedEvent('click'), this.scopedSelector(labelSelector), (e) => {
        // Label click events propagate to parent, causing a double dispatch of
        // toggleRequestSwatchSelections unless we disable propagation
        e.stopPropagation();
    });

    $(document).on(this.scopedEvent('submit'), this.scopedSelector('.js-request-swatch-selection'), (e) => {
        e.preventDefault();

        const { selectionError, selectedCount, selectedSwatches } =
            _.get(store.getState(), 'product.productRequestSwatch');

        if (selectionError) {
            return false;
        }

        let message;

        if (selectedCount < 1) {
            message = getRASMinimumMessage();
            store.dispatch(saveRequestSwatchSelectionError(message));
            return false;
        } else if (selectedCount > 10) {
            message = getRASMaximumMessage();
            store.dispatch(saveRequestSwatchSelectionError(message));
            return false;
        }

        const payload = replaceModalTransition(requestSwatchEmailSignUpInit, {}, e, self.name);

        $.event.trigger({
            type: payload.type,
            payload: payload
        });

        return false;
    });
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-request-swatch-selection',
        attachEvents: attachEvents,
        firstRender: firstRender,
        template: template,
        name: 'modal.requestSwatch',
        watch: 'product.productRequestSwatch',
        afterCloseAction: afterCloseAction,
        renderType: mDom,
        renderOptions: mDomMaintainInputValsCheckedStateSetInTemplate
    };

    return generate(config, store, overrides);
}
